// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".getStoreName[data-v-0215dd4b]{padding:100px 30px 30px 30px;display:flex;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
